// extracted by mini-css-extract-plugin
export default {"Content":"MainViewFrame_Content__EijIK"};